import $ from "jquery";
import "slick-slider";

export default () => {
  document.querySelectorAll(".js-tabbed-content-carousel").forEach((el) => {
    // initialize the carousel
    const $el = $(el);
    const $slider = $el.find(".js-carousel-track");
    const $slideNextButton = $el.find(".js-carousel-button-next");
    const $slidePrevButton = $el.find(".js-carousel-button-prev");
    const elTabButtons = el.querySelectorAll(".js-tab-button");
    const elTabSlides = el.querySelectorAll(".js-tab-slide");
    const elAnnouncer = el.querySelector(".js-carousel-announcer");

    let currentTopic = elTabButtons[0]
      ? elTabButtons[0].textContent.trim()
      : "";
    let currentIndex = 1;
    let totalSlides = elTabSlides.length;

    if (!$slider || $slider.length === 0) {
      return;
    }

    const config = {
      nextArrow: $slideNextButton,
      prevArrow: $slidePrevButton,
      dots: false,
      infinite: false,
      speed: 500,
      variableWidth: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      accessibility: true,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1190,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 910,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 690,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    const $carousel = $slider.slick(config);

    // pagination buttons.
    if (elTabButtons && elTabButtons.length > 0) {
      // Set the first tab button as active
      markActiveTab(elTabButtons[0]);

      // Go to a specific section when a tab button is clicked
      elTabButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          const topicId = e.currentTarget.getAttribute("data-topic-id");
          if (!topicId) {
            return;
          }

          markActiveTab(e.currentTarget);

          const scrollToIndex = [...elTabSlides].findIndex(
            (slide) => slide.getAttribute("data-topic-id") === topicId,
          );

          if (scrollToIndex !== -1) {
            $carousel.slick("slickGoTo", scrollToIndex);
          }
        });
      });

      // Mark the active tab button when a slide is changed
      $carousel.on("afterChange", (event, slick, currentSlide) => {
        currentIndex = currentSlide + 1;
        const currentSlideElement = elTabSlides[currentSlide];
        if (!currentSlideElement) {
          return;
        }
        const topicId = currentSlideElement.getAttribute("data-topic-id");
        if (!topicId) {
          return;
        }

        const buttonToActivate = el.querySelector(
          `.js-tab-button[data-topic-id='${topicId}']`,
        );

        markActiveTab(buttonToActivate);
        updateMessage();
      });
    }

    function updateMessage() {
      if (!elAnnouncer) {
        return;
      }
      elAnnouncer.textContent = `Slide ${currentIndex} of ${totalSlides} and the current topic is ${currentTopic}`;
    }

    function markActiveTab(elActive) {
      el.querySelectorAll(".js-tab-button.btn--active").forEach((btn) => {
        btn.classList.remove("btn--active");
      });

      if (elActive) {
        elActive.classList.add("btn--active");
        currentTopic = elActive.textContent.trim();
      }
    }
  });
};
